/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/request/~/form-data/lib/browser.js
// module id = 657
// module chunks = 0 1 2 3 4 13